import { Pipe, PipeTransform } from '@angular/core';
import { BaseEnumResponse } from '@app/models/shared.models';

@Pipe({
  name: 'baseEnumItemById',
})
export class BaseEnumItemByIdPipe implements PipeTransform {
  transform(
    id: number,
    prefix: string,
    collection: BaseEnumResponse[]
  ): string {
    const item = collection.find((value) => value.id === id);
    return item === undefined ? ' - ' : `${prefix}.${item.name}`;
  }
}
